import '../utils/get-payment-status-label.js';
import '@grandvisionhq/utils';
import { isGlassesBundleOrderLineItem, isNonPrescriptionBundleOrderLineItem, isContactLensesOrderLineItem, isSolutionOrderLineItem, isContactLensesBundleOrderLineItem } from '../utils/order-line-item-product-type-guards.js';
import '@grandvisionhq/graphql';
import { toContactLensesBundleOrderLineItem } from './contact-lenses-bundle-line-item.js';
import { toContactLensesOrderLineItem } from './contact-lenses-line-item.js';
import { toGlassesBundleOrderLineItem } from './glasses-bundle-line-item.js';
import { toNonPrescriptionBundleOrderLineItem } from './non-prescription-bundle-line-item.js';
import { toRegularOrderLineItem } from './regular-line-item.js';
import { toSolutionOrderLineItem } from './solution-line-item.js';

const toOrderLineItem = (lineItem, intl, options = {})=>{
    if (isGlassesBundleOrderLineItem(lineItem)) {
        return toGlassesBundleOrderLineItem(lineItem, intl, options);
    }
    if (isNonPrescriptionBundleOrderLineItem(lineItem)) {
        return toNonPrescriptionBundleOrderLineItem(lineItem, intl, options);
    }
    if (isContactLensesOrderLineItem(lineItem)) {
        return toContactLensesOrderLineItem(lineItem, intl, options);
    }
    if (isSolutionOrderLineItem(lineItem)) {
        return toSolutionOrderLineItem(lineItem, intl, options);
    }
    if (isContactLensesBundleOrderLineItem(lineItem)) {
        return toContactLensesBundleOrderLineItem(lineItem, intl, options);
    }
    // Default case is regular line item
    return toRegularOrderLineItem(lineItem, intl, options);
};

export { toOrderLineItem };
//# sourceMappingURL=order-line-item.js.map
